import { useState } from "react";
import "../styles/Community.css";
import { initialCardData } from "../data/communityCardData";

export default function Community() {
  const [cardData, setCardData] = useState(initialCardData);

  const [showAll, setShowAll] = useState(false);
  const [viewGallery, setViewGallery] = useState(false);
  const [galleryKey, setGalleryKey] = useState(null);

  const [selectedImage, setSelectedImage] = useState(0);

  const toggleCard = (cardId) => {
    setCardData((prevData) => {
      const updatedData = {
        ...prevData,
        [cardId]: {
          ...prevData[cardId],
          expanded: !prevData[cardId].expanded,
        },
      };

      const isAnyCardExpanded = Object.values(updatedData).some(
        (card) => card.expanded
      );

      setShowAll(isAnyCardExpanded);

      return updatedData;
    });
  };

  const toggleAllCards = () => {
    setShowAll(!showAll);

    setCardData((prevData) =>
      Object.fromEntries(
        Object.entries(prevData).map(([key, card]) => [
          key,
          card.quote !== ""
            ? { ...card, expanded: !showAll }
            : { ...card, expanded: false },
        ])
      )
    );
  };

  const toggleGallery = (key) => {
    setGalleryKey(key);
    setViewGallery(true);
    setSelectedImage(0);
    toggleCard(key);
  };

  return (
    <div className="community-container">
      {viewGallery && galleryKey && (
        <div className="gallery-modal">
          <div className="gallery-content">
            <div className="gallery-header">
              <button className="close-gallery-button hidden" disabled>
                Close Gallery
              </button>
              <h2 className="gallery-title">
                {cardData[galleryKey].title} Gallery
              </h2>

              <button
                className="close-gallery-button"
                onClick={() => setViewGallery(false)}
              >
                Close Gallery
              </button>
            </div>

            <div className="gallery-images">
              <div className="gallery-main-image">
                <img
                  src="../../assets/arrow.svg"
                  alt="next"
                  className="arrow back"
                  onClick={() =>
                    setSelectedImage(
                      (prev) =>
                        (prev - 1 + cardData[galleryKey].images.length) %
                        cardData[galleryKey].images.length
                    )
                  }
                />
                <img
                  src={cardData[galleryKey].images[selectedImage]}
                  alt="Image"
                  className="main-image"
                  loading="lazy"
                />
                <img
                  src="../../assets/arrow.svg"
                  alt="previous"
                  className="arrow next"
                  onClick={() =>
                    setSelectedImage(
                      (prev) => (prev + 1) % cardData[galleryKey].images.length
                    )
                  }
                />
              </div>
              <div className="gallery-selector">
                {cardData[galleryKey].images.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`${cardData[galleryKey].title} Image ${index + 1}`}
                    className={`gallery-image ${
                      index === selectedImage ? "selected" : ""
                    }`}
                    onClick={() => setSelectedImage(index)}
                    loading="lazy"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="community-content">
        <div className="community-content-header">
          <h2 className="community-title">Our Sponsorships</h2>

          <div className="expand-button" onClick={() => toggleAllCards()}>
            <div className="card-toggle-icon-container">
              <img
                src="../../assets/arrow_collapse.svg"
                alt=""
                className={`card-toggle-icon top-left ${
                  showAll ? "expanded" : ""
                }`}
              />
              <img
                src="../../assets/arrow_collapse.svg"
                alt=""
                className={`card-toggle-icon bottom-left ${
                  showAll ? "expanded" : ""
                }`}
              />
            </div>
            <p className="expand-button-text">
              {showAll ? "Collapse All " : "Expand All "}
            </p>
            <div className="card-toggle-icon-container">
              <img
                src="../../assets/arrow_collapse.svg"
                alt=""
                className={`card-toggle-icon top-right ${
                  showAll ? "expanded" : ""
                }`}
              />
              <img
                src="../../assets/arrow_collapse.svg"
                alt=""
                className={`card-toggle-icon bottom-right ${
                  showAll ? "expanded" : ""
                }`}
              />
            </div>
          </div>
        </div>

        <div className="community-body">
          {Object.entries(cardData).map(
            ([key, { title, logo, quote, url, expanded, images }]) => (
              <div
                className={`community-card ${expanded ? "expanded" : ""}`}
                onClick={quote !== "" ? () => toggleCard(key) : null}
                key={key}
              >
                <div className="community-card-header">
                  <div className="community-logo-container">
                    {images.length >= 1 && (
                      <img
                        src="../../assets/gallery.svg"
                        className={`gallery-button ${
                          expanded ? "expanded" : ""
                        } hidden`}
                      />
                    )}
                    <img
                      src={logo}
                      alt={key}
                      className={`community-logo ${expanded ? "expanded" : ""}`}
                      loading="lazy"
                    />

                    {images.length >= 1 && (
                      <img
                        src="../../assets/gallery.svg"
                        className={`gallery-button ${
                          expanded ? "expanded" : ""
                        }`}
                        onClick={expanded ? () => toggleGallery(key) : null}
                      />
                    )}
                  </div>
                  <div
                    className={`community-header ${expanded ? "expanded" : ""}`}
                  >
                    <a
                      href={url !== "" ? url : null}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() => toggleCard(key)}
                    >
                      <h3 className="community-card-title">{title}</h3>

                      {url !== "" && (
                        <img
                          src="../../assets/pop_out.svg"
                          alt="View Site"
                          className="community-header-icon"
                        />
                      )}
                    </a>
                  </div>
                  <div className="community-card-content">
                    <p className="community-quote">{quote}</p>
                  </div>
                </div>

                <div className="community-card-footer">
                  {quote !== "" && (
                    <p className="community-footer-text">
                      {expanded ? "Click to collapse" : "Click to expand"}
                    </p>
                  )}
                </div>
              </div>
            )
          )}
        </div>
      </div>
    </div>
  );
}
